import baliBeach from './images/bali-beach.svg';
import dogBranch from './images/dog-branch.svg';
import nzMountains from './images/nz-mountains.svg';
import shavedCat from './images/shaved-cat.svg';

export const travelData = {
  content: [
    {
      cta: {
        name: 'Find out more about Bali Travel Insurance',
        url: '/travel-insurance/bali',
      },
      description:
        'Bali is one of the most beloved destinations for Aussie travellers. ahm has a range of travel insurance cover options to suit your Bali getaway.',
      imageObject: {
        caption: 'Bali beach',
        image: {
          asset: {
            _id: 'bali-image',
            url: baliBeach.src,
          },
        },
      },
      title: 'Bali',
    },
    {
      cta: {
        name: 'Find out more about New Zealand Travel Insurance',
        url: '/travel-insurance/new-zealand',
      },
      description:
        'Whether you’re planning a summer getaway or a winter break, ahm has travel insurance for your New Zealand trip.',
      imageObject: {
        caption: 'New Zealand mountains',
        image: {
          asset: {
            _id: 'nz-image',
            url: nzMountains.src,
          },
        },
      },
      title: 'New Zealand',
    },
  ],
  subtitle:
    'We know how much Aussies love flocking overseas, so we’ve simplified your travel insurance search with some of ahm customers’ favourite destinations.',
  title: 'Popular destinations',
};

export const petData = {
  content: [
    {
      description:
        'Whether your feline friend is an indoor-only cat, or the more adventurous outdoor type, cover is available for them.',

      imageObject: {
        caption: 'Fluffy to shaved cat',
        image: {
          asset: {
            _id: 'cat-image',
            url: shavedCat.src,
          },
        },
      },
      listItems: [
        'Depending on the level of cover you chose for your cat and their age when you first sign up, choose between Bronze, Gold or Platinum cover.',
        'Your choice of $500, $250 or $0 excess payable if you make a claim. Excess is applied on a per condition, per policy period basis.',
        'Choose between specified accidental injury and illness cover, or specified conditions cover. Includes cover for consultations and emergency boarding. Sub-limits apply.',
      ],
      title: 'Cat insurance',
    },

    {
      description: 'Whether your best mate is a puppy or a fully grown dog, help protect them from snout to tail.',
      imageObject: {
        caption: 'Dog carrying a branch',
        image: {
          asset: {
            _id: 'dog-image',
            url: dogBranch.src,
          },
        },
      },
      listItems: [
        'Depending on the level of cover you chose for your dog and their age when you first sign up, choose between Silver, Gold or Platinum cover.',
        'Your choice of $500, $250 or $0 excess payable if you make a claim. Excess is applied on a per condition, per policy period basis.',
        'Choose between specified accidental injury and illness cover or our specified accidental injuries and specified illness cover.',
        'Includes cover for consultations and emergency boarding. Sub-limits apply.',
      ],
      title: 'Dog insurance',
    },
  ],
  subtitle:
    'Whether you’re a cat person, a dog person, or lucky enough to be both - your furry family deserves the best.',
  title: 'We’re cat and dog people!',
};
